import React from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import { LinkButton } from '@strava/ui/Button';
import { useStravaBranch } from '@strava/container-context';
import { getProfileVisibility } from '../../helpers/getProfileVisibility';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';

import styles from './DownloadStrava.module.scss';

const DownloadStrava = ({ className }) => {
  const { t, track, state } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete } = athleteData;
  const branch = useStravaBranch();

  const { appLink } = branch;

  return (
    <LinkButton
      className={clsx(styles.downloadStrava, className)}
      href={appLink}
      variant="primary"
      onClick={() =>
        track({
          action: 'click',
          element: 'get_app',
          properties: {
            profile_visibility: getProfileVisibility(athlete),
            cta_copy: 'download_strava',
            url: appLink
          }
        })
      }
    >
      {t('download_strava')}
    </LinkButton>
  );
};

DownloadStrava.defaultProps = {
  className: null
};

DownloadStrava.propTypes = {
  className: PropTypes.string
};

export default DownloadStrava;
